export default "__VITE_ASSET__4NPYyhkC__"